module.exports = __webpack_public_path__ + "assets/img/academic-paper.77408dfb.svg";